import { render, staticRenderFns } from "./ComissaoVendas.vue?vue&type=template&id=6337396e"
import script from "./ComissaoVendas.vue?vue&type=script&lang=js"
export * from "./ComissaoVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports